// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3zKUX"};